import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";
import RoutesLocal from "./Routes";
import "./index.css";
import "@adobe/adobe-client-data-layer";

import "./styles/components/_header.scss";
import "./styles/components/_form.scss";
import "./styles/components/_ltcheader.scss";
import "./styles/components/_ltcbanner.scss";
import "./styles/components/_ltcform.scss";
import "./styles/components/_manulifeheader.scss";
import "./styles/components/_manulifefooter.scss";
import "./styles/components/_manulifeform.scss";
import "./styles/components/_vitalityheader.scss";
import "./styles/components/_vitalityform.scss";
import "./styles/components/_vitalityfooter.scss";
import "./styles/components/_jhHeader.scss";
import "./styles/components/_updateprofileform.scss";
import "./styles/components/_jhform.scss";
import "./styles/components/_errorpage.scss";
import "./styles/components/_harvestForm.scss";
import "./styles/components/_mydashboardform.scss";
import "./styles/components/_mydashboardmanageprofileform.scss";
import "./styles/components/_vitalityregistrationv1.scss";
import "./styles/components/_registrationv1form.scss";

import "@manulife/mux/core/typography/assets/fonts/fonts.css";
// import ErrorBoundary from "./utils/ErrorBoundary";

ReactDOM.render(<RoutesLocal />, document.getElementById("root"));
